import { useEffect } from 'react'
import { isTokenExpired, logout } from '../services/authorizationService'

/**
 * Hook que valida periódicamente si el token ha expirado
 * Si expira, dispara el logout y redirige al login
 * @param {number} checkIntervalMs - Intervalo de validación en milisegundos (default: 30 segundos)
 */
export const useTokenExpiration = (checkIntervalMs = 30000) => {
    useEffect(() => {
        // Crear un intervalo para verificar la expiración
        const tokenCheckInterval = setInterval(() => {
            if (isTokenExpired()) {
                // El token ha expirado
                logout()
                
                // Redirigir al login
                window.location.href = '/login'
                
                // Limpiar el intervalo
                clearInterval(tokenCheckInterval)
            }
        }, checkIntervalMs)

        // Limpiar el intervalo cuando se desmonte el componente
        return () => {
            clearInterval(tokenCheckInterval)
        }
    }, [checkIntervalMs])
}
